(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userCategoryService', userCategoryService);

    /* @ngInject */
    function userCategoryService(coreService, $odataresource, config) {
        var service = {
            saveUserCategory: saveUserCategory,
            getUserCategoryFields: getUserCategoryFields,
            getUserCategories: getUserCategories,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig,
            getModalOptions: getModalOptions,
            getDefaultUserCategory: getDefaultUserCategory
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/UserCategories',
                {},
                {},
                {
                    odatakey: 'UserCategoryId',
                    isodatav4: true
                });
        }

        function saveUserCategory(userCategory) {
            return coreService.httpAccountsPost('user/category' ,userCategory);
        }

        function getUserCategoryFields() {
            var fields = [
                {
                    key: 'UserCategoryName',
                    type: 'input',
                    templateOptions: {
                        type: 'text',
                        label: 'Category Name',
                        placeholder: 'Enter the Category Name',
                        required: true,
                        maxlength: 100
                    }
                }, {
                    key: 'Level',
                    type: 'input',
                    templateOptions: {
                        type: 'number',
                        label: 'Level',
                        placeholder: 'Enter the Level of this user category',
                        required: true,
                        min: 1,
                        max: 100
                    }
                }];
            return fields;
        }

        function getUserCategories(tableState) {
            var query = service.getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject,
                    getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'Level', reverse: false
            };
            coreService.processODataSort(query, tableState.sort);

            return query                
                .withInlineCount()
                .query()
                .$promise;
        }

        function getTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'Level',
                        displayName: 'Category Level',
                        ODataKey: 'Level',
                        type: 'match'
                    },
                    {
                        id: 'UserCategoryName',
                        displayName: 'User Category Name',
                        ODataKey: 'UserCategoryName',
                        type: 'match'
                    }                    
                ],
                actions: []
            };
            return tableConfig;
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/settings/category/modal/category.modal.html',
                controllerAs: 'vm'
            };
        }

        function getDefaultUserCategory() {
            return {
                UserCategoryId: 0,
                UserCategoryName: ''
            };
        }
    }
})();
